<div
  class="cat-div"
  matTooltip="Category"
  [ngClass]="{
    'ddc-cat-light': _isLightTheme,
    'ddc-cat-dark': _isDarkTheme,
    'ddc-cat-paper': _isPaperTheme,
  }"
>
  <span class="material-icons ddc-chip-icon">category</span>
  <div>{{ label }}</div>
</div>
